import { httpClient } from '../util/http-client'

export const fetchDetail = async (url: string) => {
  const { data } = await httpClient(url)

  return data
}
